import { GOLD, PRIME_GOLD_TRANSLUCENT } from '@propertypal/shared/src/styles/theme';
import Link from 'next/link';
import styled from 'styled-components';

export const CarouselRoot = styled.div`
  width: 100%;
  padding: 12px;
  position: relative;
`;

export const Curtain = styled.div`
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 1%, rgba(255, 255, 255, 1) 100%);
  position: absolute;
  height: 100%;
  width: 30px;
  top: 0;
  right: 10px;
  z-index: 2;
  pointer-events: none;
`;

export const SmallPropertyCard = styled(Link)`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  overflow: hidden;
  background: ${({ theme }) => theme.background};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  height: calc(100% - 5px);

  &:hover {
    background-color: ${({ theme }) => theme.backgroundLighter};
  }

  &:visited h2 {
    color: ${({ theme }) => theme.backgroundMid};
  }
`;

export const SmallPropertyBody = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const LinkBox = styled.div`
  background-color: ${PRIME_GOLD_TRANSLUCENT};
  width: 250px;
  height: calc(100% - 5px);
  border-radius: 6px;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 10px;
  color: ${({ theme }) => theme.textDark};

  h3,
  p {
    text-align: center;
  }

  p {
    color: ${GOLD};

    &:hover {
      text-decoration: underline;
    }
  }
`;
